import { render, staticRenderFns } from "./ChangeOwenr.vue?vue&type=template&id=4cdd847c&"
import script from "./ChangeOwenr.vue?vue&type=script&lang=js&"
export * from "./ChangeOwenr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports